export function getUserInitials(firstName = '', lastName = '') {
  return `${firstName[0] || ''}${lastName[0] || ''}`;
}

export function getStaffUserInitials(name = '') {
  return name
    .split(' ')
    .filter(Boolean)
    .map((chunk) => chunk[0])
    .join('');
}
